import { render, staticRenderFns } from "./saveRecipeButtonWrapper.vue?vue&type=template&id=cd4da188&"
import script from "./saveRecipeButtonWrapper.vue?vue&type=script&lang=js&"
export * from "./saveRecipeButtonWrapper.vue?vue&type=script&lang=js&"
import style0 from "./saveRecipeButtonWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports